"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CausticLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CausticLinear = function CausticLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.291.82c.18.064.273.259.208.434l-.12.318 6.478 2.345c.901.32 1.366 1.29 1.038 2.17-.328.877-1.324 1.33-2.225 1.01L7.192 4.754l-.118.318a.35.35 0 01-.445.202.336.336 0 01-.208-.434l.356-.954 7.13 2.576a1.05 1.05 0 001.335-.606 1.008 1.008 0 00-.622-1.302L7.49 1.977l.356-.954A.35.35 0 018.291.82zm3.304 3.02l2.906 1.031c.36.128.546.516.415.868a.7.7 0 01-.89.404L7.534 3.84h4.061zM10.4 8.17a.721.721 0 00-.721-.722h-2.48l-.01.12a1.6 1.6 0 01-3.185-.08H4l-.52.222-.171.08a3.2 3.2 0 00-1.435 1.43l-.275.55H.8l-.093.005A.8.8 0 000 10.57v2.4l.005.093a.8.8 0 00.795.707h.8l.987.658.215.137a5.6 5.6 0 002.895.804l5.584-.003.09-.006a.719.719 0 00-.09-1.431H9.69l-.035-.007a.09.09 0 01.035-.174h3.191l.09-.006a.718.718 0 00-.09-1.43H9.69l-.029-.005a.09.09 0 01.029-.177h3.988l.09-.005a.721.721 0 00-.09-1.437H9.69l-.029-.005a.09.09 0 01.029-.176h2.391l.09-.006a.718.718 0 00-.09-1.43h-4.79l-.03-.005a.09.09 0 01.03-.177h2.387l.09-.005a.722.722 0 00.631-.716zm-4-.798a.8.8 0 10-1.6 0 .8.8 0 001.6 0z",
    fill: "currentColor"
  }));
};

exports.CausticLinear = CausticLinear;
var _default = CausticLinear;
exports.default = _default;